import React from 'react';

export default function CircularProgress({ progress = 0, onCancel, size = 48, speed = 0 }) {
  const radius = (size / 2) - 4;
  const circumference = 2 * Math.PI * radius;

  // 🆕 پشتیبانی از هر دو شکل: عدد خالص یا آبجکت { percent, loaded, total }
  const rawProgress =
    progress && typeof progress === 'object'
      ? (progress.percent ?? 0)
      : progress;
  const safeProgress = Math.max(0, Math.min(100, Number(rawProgress) || 0));
  const offset = circumference - (safeProgress / 100) * circumference;

  const formatSpeed = (bytesPerSec) => {
    if (!bytesPerSec || bytesPerSec < 1) return '';
    if (bytesPerSec < 1024) return `${Math.round(bytesPerSec)} B/s`;
    if (bytesPerSec < 1024 * 1024) return `${(bytesPerSec / 1024).toFixed(1)} KB/s`;
    return `${(bytesPerSec / (1024 * 1024)).toFixed(2)} MB/s`;
  };

  const speedLabel = formatSpeed(speed);

  return (
    <div style={{ position: 'relative', width: size, height: size, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#e2e8f0" strokeWidth="4" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={radius}
          stroke="#6C5CE7" strokeWidth="4" fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 0.2s ease' }}
        />
      </svg>
      <span style={{ position: 'absolute', fontSize: size * 0.22, fontWeight: 'bold', color: '#334155' }}>
        {safeProgress}%
      </span>
      {speedLabel && (
        <span
          style={{
            position: 'absolute',
            bottom: -14,
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: 9,
            color: '#64748b',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}
        >
          {speedLabel}
        </span>
      )}
      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          style={{ position: 'absolute', top: -6, right: -6, background: '#ef4444', color: 'white', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', fontSize: 10, boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}
          title="لغو آپلود"
        >
          ✕
        </button>
      )}
    </div>
  );
}